module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/propertiesregister/propertiesregister.component.css
// module id = ./src/app/planning/propertiesregister/propertiesregister.component.css
// module chunks = main